import React, { useEffect } from "react";
import { ResponsiveDeviceType } from "../../../../widget/layouts/ScreenMedia";
import Scaffold from "../../../../widget/layouts/Scaffold";
import { MainBodyContainer } from "../../../../widget/common/ui/MainContainer";
import SignupAccountVerificationButtons from "./widget/SignupAccountVerificationButtons";
import SignupAccountVerificationContent from "./SignupAccountVerificationContent";
import { appRoutes } from "../../../../routes/routes";
import { navigate } from "../../../../service/navigation/Navigation";
import { SignupAccountVerificationContextProvider } from "../../../../provider/onboarding/signup/account_verification/SignupAccountVerificationContextProvider";
import AppConfigService from "../../../../service/app_config/AppConfigService";
import SignupAccountVerificationProvider from "../../../../provider/onboarding/signup/account_verification/SignupAccountVerificationProvider";

const SignupAccountVerificationScreen = () => {
  const type: number = ResponsiveDeviceType();

  const checkVericationSession = () => {
    const checkAccess: boolean =
      SignupAccountVerificationProvider.checkAccess();
    if (!checkAccess) {
      navigate(appRoutes.routeNameLogin, { replace: true });
    }

    /*  const verificationSession = SessionStorage.getValue(
      StorageKeys.signup_verification_detail
    );
    if (UtilityHelper.isEmpty(verificationSession)) {
      navigate(appRoutes.routeNameLogin, { replace: true });
    } */
  };

  useEffect(() => {
    checkVericationSession();
  }, []);

  return (
    <SignupAccountVerificationContextProvider>
      <Scaffold
        appBarTitle={
          type === 3 ? undefined : AppConfigService.get("company_name")
        }
        bottomNavigationButton={<SignupAccountVerificationButtons />}
        disabledBack={true}
      >
        <MainBodyContainer>
          <SignupAccountVerificationContent type={type} />
        </MainBodyContainer>
      </Scaffold>
    </SignupAccountVerificationContextProvider>
  );
};

export default SignupAccountVerificationScreen;
export const routeName: string = "/signup/account-verification";
export const routeNameForgotPasswordVerification: string =
  "/forgot-password-verification";
